import { useQuery } from "@tanstack/react-query";
import { savingsApi } from "@/lib/savings.api";
import { queryKeys } from "@/lib/query-keys";
import { isAxiosError } from "axios";
import { isValidRecordId } from "@/lib/route-id";

export function usePartySavingsAccount(partyId: number) {
  return useQuery({
    queryKey: queryKeys.savings(partyId),
    enabled: isValidRecordId(partyId),
    queryFn: () =>
      savingsApi
        .getAccountByParty(partyId)
        .then((r) => r.data)
        .catch((error: unknown) => {
          if (isAxiosError(error) && error.response?.status === 404) return null;
          throw error;
        }),
  });
}
